/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ErrorMessage } from '../model/errorMessage';
// @ts-ignore
import { SystemLog } from '../model/systemLog';
// @ts-ignore
import { SystemLogTrackEventRequest } from '../model/systemLogTrackEventRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface GetSystemLogRequestParams {
  /** Reporting code ids for filtering */
  reportingCodeIds?: Array<number>;
  /** Include Account IDs for filtering. Can be filled if \&#39;excludeAccountIds\&#39; is empty. */
  accountId?: Array<number>;
  /** Exclude Account IDs for filtering. Can be filled if \&#39;accountId\&#39; is empty. */
  excludeAccountIds?: Array<number>;
  /** Include User IDs for filtering. Can be filled if \&#39;excludeUserIds\&#39; is empty. */
  userId?: Array<number>;
  /** Exclude User IDs for filtering. Can be filled if \&#39;userId\&#39; is empty. */
  excludeUserIds?: Array<number>;
  /** Sort direction by time. ASC or DESC(default). */
  sortDirection?: 'ASC' | 'DESC';
  /** Skip count, should be &gt;&#x3D; 0. Default 0. */
  skipCount?: number;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
}

export interface TrackEventRequestParams {
  systemLogTrackEventRequest: SystemLogTrackEventRequest;
}

@Injectable({
  providedIn: 'root',
})
export class SystemLogControllerService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Gets last system actions(up to 100)
   * @endpoint get /v1/system-log
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getSystemLog(
    requestParameters?: GetSystemLogRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<SystemLog>>;
  public getSystemLog(
    requestParameters?: GetSystemLogRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<SystemLog>>>;
  public getSystemLog(
    requestParameters?: GetSystemLogRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<SystemLog>>>;
  public getSystemLog(
    requestParameters?: GetSystemLogRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const reportingCodeIds = requestParameters?.reportingCodeIds;
    const accountId = requestParameters?.accountId;
    const excludeAccountIds = requestParameters?.excludeAccountIds;
    const userId = requestParameters?.userId;
    const excludeUserIds = requestParameters?.excludeUserIds;
    const sortDirection = requestParameters?.sortDirection;
    const skipCount = requestParameters?.skipCount;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'reportingCodeIds',
      <any>reportingCodeIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeAccountIds',
      <any>excludeAccountIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'userId',
      <any>userId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeUserIds',
      <any>excludeUserIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'sortDirection',
      <any>sortDirection,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipCount',
      <any>skipCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/system-log`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<SystemLog>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Track event
   * @endpoint post /v1/system-log
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public trackEvent(
    requestParameters: TrackEventRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any>;
  public trackEvent(
    requestParameters: TrackEventRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<any>>;
  public trackEvent(
    requestParameters: TrackEventRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<any>>;
  public trackEvent(
    requestParameters: TrackEventRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const systemLogTrackEventRequest = requestParameters?.systemLogTrackEventRequest;
    if (systemLogTrackEventRequest === null || systemLogTrackEventRequest === undefined) {
      throw new Error('Required parameter systemLogTrackEventRequest was null or undefined when calling trackEvent.');
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/system-log`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: systemLogTrackEventRequest,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
